module.exports = __webpack_public_path__ + "static/media/cq_piu_b.f9d8c895.svg";